"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpContextHeaders = void 0;
var HttpContextHeaders;
(function (HttpContextHeaders) {
    HttpContextHeaders.CORRELATION_ID = "x-lv-correlation_id";
    HttpContextHeaders.EXECUTION_ID = "x-lv-execution_id";
    HttpContextHeaders.ACTOR_ID = "x-lv-x-lv-actor_id";
})(HttpContextHeaders = exports.HttpContextHeaders || (exports.HttpContextHeaders = {}));
//# sourceMappingURL=HttpContextHeaders.js.map